<div class="row">
     <div class="col-12">
       <div class="row justify-content-between align-items-center" id="page-title">
         <h1 class="progress-header col-12 col-lg-auto" [innerHTML]="'Enroll in PSP_MAIN' | translator:'base'">
           Enroll in PSP
         </h1>
       </div>
       <div class="row mb-2">
         <span class="col-12 col-lg-auto d-flex align-items-center small">
           <i class="fas fa-triangle-exclamation me-2" aria-hidden="true"></i>
           <span [innerHTML]="'Start_8-1' | translator:'base'">
             Are you a <strong>driver</strong> looking for your own PSP record?
           </span>
           <a routerLink="/driver/1"
             (click)="scrollToTop()"
             name="Driver-record-request"
             id="Driver-record-request"
             [title]="'Start_8-2' | translator:'base'" 
             class="ms-1" 
            >
             <span [innerHTML]="'Start_8-2' | translator:'base'">Access your PSP record here.</span>
           </a>
         </span>
       </div>
       <div class="row">
         <div class="col-lg-8">
           <div class="card shadow-sm rounded-0 border-0">
             <div class="card-body">
               <app-complete-bar  [step]="7" [totalSteps]="19"></app-complete-bar >
               <h2 [innerHTML]="'FEES_1' | translator:'base'">PSP Fees</h2>
               <hr>
               <p>
                 <strong [innerHTML]="'FEES_2' | translator:'base'">NIC Federal, LLC is the exclusive agent
                   for online access to the FMCSA Pre-Employment Screening Program (PSP) records.</strong>
               </p>
               <p [innerHTML]="'FEES_3' | translator:'base'">
                 Your account will be activated immediately upon approval of your agreement. You will
                 not be billed during the enrollment process.
               </p>
               <p [innerHTML]="'FEES_4' | translator:'base'">
                 The fee structure for motor carriers appears in the table below:
               </p>
               <table class="table table-collapsible">
                 <thead>
                   <tr>
                     <th scope="col" [innerHTML]="'FEES_5' | translator:'base'" class="" style="width: 15%;">
                       Account Type
                     </th>
                     <th scope="col" [innerHTML]="'FEES_6' | translator:'base'" class="" style="width: 15%;">
                       Subscription Fee
                     </th>
                     <th scope="col" [innerHTML]="'FEES_7' | translator:'base'" class="" style="width: 20%;">
                       Transaction&nbsp;Fee&#42;
                     </th>
                     <th scope="col" [innerHTML]="'FEES_8' | translator:'base'" class="" style="width: 18%;">
                       Billing
                     </th>
                   </tr>
                 </thead>
                 <tbody>
                   <tr>
                     <td class="bold">
                       <span class="cell-label" [innerHTML]="'FEES_5' | translator:'base'">
                         Account Type
                       </span>
                       <span [innerHTML]="'FEES_8_a' | translator:'base'">
                         Motor carrier with fewer than 100 power units
                       </span>
                     </td>
                     <td>
                       <span class="cell-label" [innerHTML]="'FEES_6' | translator:'base'">
                         Subscription Fee
                       </span>
                       <span [innerHTML]="'FEES_17' | translator:'base'">
                         $25 annually, limited to 10 users
                       </span>
                     </td>
                     <td>
                       <span class="cell-label" [innerHTML]="'FEES_7' | translator:'base'">
                         Transaction&nbsp;Fee&#42;
                       </span>
                       <span [innerHTML]="'FEES_10' | translator:'base'">
                         <p><strong>$10.00/record: </strong><span class="records-num-nowrap text-nowrap">1 &#8210; 10</span> records</p>
                         <!-- ... other records ... -->
                       </span>
                     </td>
                     <td>
                       <span class="cell-label" [innerHTML]="'FEES_8' | translator:'base'">
                         Billing
                       </span>
                       <span [innerHTML]="'FEES_11' | translator:'base'">
                         Monthly email invoice for records requested. Annual subscription fee is charged once each year.
                       </span>
                     </td>
                   </tr>
                   <tr>
                    <td
                         class="bold"
                    >
                         <span 
                              class="cell-label" 
                              [innerHTML]="'FEES_5' | translator:'base'" 
                         >Account Type</span>
                         <span [innerHTML]="'FEES_12' | translator:'base'">		
                              Motor carrier with more than 100 power units
                         </span>
                    </td>
                    <td>
                         <span 
                              class="cell-label" 
                              [innerHTML]="'FEES_6' | translator:'base'" 
                         >Subscription Fee</span>
                         <span [innerHTML]="'FEES_13' | translator:'base'">				
                              $100 annually, limited to 10 users
                         </span>
                    </td>
                    <td>
                         <span 
                              class="cell-label" 
                              [innerHTML]="'FEES_7' | translator:'base'" 
                         >Transaction&nbsp;Fee&#42;</span>
                         <span [innerHTML]="'FEES_14' | translator:'base'">												
                              <p><strong>$10.00/record: </strong><span class="records-num-nowrap text-nowrap">1 &#8210; 10</span> records</p>
                              <p><strong>$9.50/record: </strong><span class="records-num-nowrap text-nowrap">11 &#8210; 20</span> records</p>
                              <p><strong>$9.25/record: </strong><span class="records-num-nowrap text-nowrap">21 &#8210; 40</span> records</p>
                              <p><strong>$9.00/record: </strong><span class="records-num-nowrap text-nowrap">41 &#8210; 100</span> records</p>
                              <p><strong>$8.75/record: </strong><span class="records-num-nowrap text-nowrap">100 &#43;</span> records</p>
                         </span>		
                    </td>												
                    <td>
                         <span 
                              class="cell-label" 
                              [innerHTML]="'FEES_8' | translator:'base'" 
                         >Billing</span>
                         <span [innerHTML]="'FEES_15' | translator:'base'">						
                              Monthly email invoice for records requested. Annual subscription fee is charged once each year.
                         </span>
                    </td>
               </tr>
                 </tbody>
               </table>
               <p class="fw-bold mb-0" [innerHTML]="'FEES_16' | translator:'base'">&#42;Quantity discounts are available for simultaneous record requests.</p>
               <div class="d-flex flex-row-reverse justify-content-between mt-4 btn-group-wizard">
                 <div class="btn-group" role="group">
                   <a routerLink="/signup/12"
                     class="btn btn-primary btn-strong"
                     (click)="scrollToTop()"
                     [title]="'PrimaryContact' | translator:'base'"
                     name="companyNext11"
                     id="companyNext11"
                   >
                     <span [innerHTML]="'Continue' | translator:'base'">Continue</span>
                     <span class="sr-only">&nbsp;</span>
                     <span class="sr-only" [innerHTML]="'PrimaryContact' | translator:'base'">Primary Contact</span>
                 </a>
                 </div>
                 <div class="btn-group" role="group">
                   <button 
                      [routerLink]="enrollmentService.newCustomer!.customerType === customerType.AH ? '/signup/10' : '/signup/9'"
                      class="btn btn-outline-primary"
                      [title]="'CompanyInfo' | translator:'base'"
                      name="companyBack11"
                      id="companyBack11"
                    >
                     <span [innerHTML]="'Back' | translator:'base'">Back</span>
                     <span class="sr-only" [innerHTML]="'CompanyInfo' | translator:'base'">Monthly Account Holder Info</span>
                   </button>
                   <a routerLink="/"
                     tag="button"
                     class="btn btn-light"
                     (click)="scrollToTop()"
                     name="companyCancel11"
                     [innerHTML]="'Cancel' | translator:'base'"
                     [title]="'Cancel' | translator:'base'"
                    >
                     Cancel
                   </a>
                 </div>
               </div>
             </div>
           </div>
         </div>
         <app-progress-wizard [wizardObj]="wizardObj" [activeStep]="2"
                    [pageType]="enrollmentService.newCustomer!.customerType || '-'"
                    class="col-lg-4 sidebar d-none d-lg-block"></app-progress-wizard>
       </div>
     </div>
   </div>
   
